var React = require('react');

function PencilIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.8 33.78l.003 1.781a2.85 2.85 0 013.617 3.635l1.763.004 2.946-2.946-5.4-5.4L8.8 33.78zM30.018 12.6l5.385 5.38-15.588 15.588-5.397-5.397 15.6-15.572zm6.485-6.486l5.383 5.383a3.797 3.797 0 01.003 5.37l-25.45 25.449c-.369.37-1.09.67-1.624.67H6.9A1.898 1.898 0 015 41.084v-7.913c0-.528.304-1.26.67-1.625L31.132 6.11a3.8 3.8 0 015.371.004z","fillRule":"evenodd"}));
}

PencilIcon.displayName = "PencilIcon";

PencilIcon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 48 48"};

module.exports = PencilIcon;

PencilIcon.default = PencilIcon;
